module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-container"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "email",
      "type": "email",
      "name": "EMAIL",
      "placeholder": "Enter email address"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('EMAIL')),
      expression: "errors.has('EMAIL')"
    }],
    staticClass: "newsletter-error"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errors.first('EMAIL')))])]), _vm._v(" "), _c('input', {
    class: {
      disabled: _vm.errors.has('EMAIL')
    },
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "submit",
      "data-vv-validate-on": "none"
    },
    on: {
      "blur": function($event) {
        return _vm.resetForm()
      }
    }
  })]), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "thank-you"
  }, [_c('p', [_vm._v("Thank you for your submission")])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage && !_vm.successMessage) ? _c('div', {
    staticClass: "thank-you"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a9da5db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsletter.vue
// module id = 1526
// module chunks = 0